module.exports = __webpack_public_path__ + "img/Regenschirm.e2008130.webp";